(() => {
  const MOBILE = window.matchMedia('(max-width: 760px)');
  const setup = (track) => {
    if (!track || track.dataset.wardsSwipeGallery === 'true') return;
    const slides = [...track.children].filter(el => el.matches('.product-gallery-item, .aerosol-v2__media'));
    if (slides.length < 2) return;
    track.dataset.wardsSwipeGallery = 'true';
    const nav = document.createElement('div');
    nav.className = 'wards-mobile-gallery-nav';
    nav.setAttribute('aria-label', 'Product image navigation');
    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wards-mobile-gallery-dot';
      dot.setAttribute('aria-label', `View product image ${index + 1} of ${slides.length}`);
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
      nav.appendChild(dot);
      return dot;
    });
    const count = document.createElement('span');
    count.className = 'wards-mobile-gallery-count';
    count.textContent = `1 / ${slides.length}`;
    nav.appendChild(count);
    track.insertAdjacentElement('afterend', nav);
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!MOBILE.matches) return;
      const centre = track.scrollLeft + track.clientWidth / 2;
      let active = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const slideCentre = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(slideCentre - centre);
        if (distance < best) { best = distance; active = i; }
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
      count.textContent = `${active + 1} / ${slides.length}`;
    };
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };
  const init = () => document.querySelectorAll('.product-gallery-main, .aerosol-v2__gallery').forEach(setup);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
